/* TODO: t() */
import React, { Fragment } from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';

import { themeColors } from './Constants';
import Text from './Text';
import Separator from './Separator';

type SegmentProps = {
  active: boolean;
  title: string;
  onPress?: (() => void) | undefined;
};

type SegmentType<T> = {
  title: string;
  value: T;
};

type Props<T> = {
  activeSegment: T;
  segments: Array<SegmentType<T>>;
  onChange: (arg0: T) => void;
};

// Ref: https://developer.apple.com/design/human-interface-guidelines/ios/controls/segmented-controls/
export default function SegmentedControl<T>(props: Props<T>) {
  let { activeSegment, segments, onChange } = props;
  return (
    <View style={styles.root}>
      {segments.map((segment, i) => (
        <Fragment key={i}>
          {i !== 0 && (
            <Separator direction="vertical" style={styles.separator} />
          )}
          <Segment
            active={activeSegment === segment.value}
            title={
              typeof segment.title === 'string'
                ? segment.title
                : String(segment.title)
            }
            onPress={() => onChange(segment.value)}
          />
        </Fragment>
      ))}
    </View>
  );
}

let Segment = ({ active, title, onPress }: SegmentProps) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={0.6}
      style={[styles.segment, active && styles.activeSegment]}
    >
      <Text style={[styles.segmentText, active && styles.activeSegmentText]}>
        {title}
      </Text>
    </TouchableOpacity>
  );
};

let transition = {
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-out',
};

let styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    borderRadius: 3,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.blue,
    overflow: 'hidden',
  },
  segment: {
    flex: 1,
    padding: 3,
    backgroundColor: themeColors.white,
    alignItems: 'center',
    justifyContent: 'center',
    ...transition,
    transitionProperty: 'background-color',
  },
  activeSegment: {
    backgroundColor: themeColors.blue,
  },
  separator: {
    backgroundColor: themeColors.blue,
  },
  segmentText: {
    color: themeColors.blue,
    ...transition,
    transitionProperty: 'color',
  },
  activeSegmentText: {
    color: themeColors.white,
  },
});
